export const DEFAULT_DURATION = { faster: 0.1, medium: 0.2, slower: 0.3 };
export const MOTION_DEFAULTS = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
    transition: { duration: DEFAULT_DURATION.medium, ease: "easeOut" }
};
export const DEFAULT_CHILD_ANIMATION_DELAY = 450; // milliseconds
